"use client";

import { useId, useState } from "react";

import {
  CALENDAR_PREVIEW_CLASS_MAP,
  CALENDAR_PREVIEW_DEFAULTS,
  type TCalendarPreviewProps,
} from "@/ui/components/form/Calendar/CalendarPreview.config";
import {
  CalendarPreviewHeader,
} from "@/ui/components/form/Calendar/CalendarPreviewHeader";
import {
  CalendarPreviewPanel,
} from "@/ui/components/form/Calendar/CalendarPreviewPanel";

export const CalendarPreview = ({
  calendar,
  closeLabel = CALENDAR_PREVIEW_DEFAULTS.closeLabel,
  date,
  defaultOpen = CALENDAR_PREVIEW_DEFAULTS.defaultOpen,
  editLabel = CALENDAR_PREVIEW_DEFAULTS.editLabel,
  id,
  title = CALENDAR_PREVIEW_DEFAULTS.title,
}: TCalendarPreviewProps) => {
  const generatedId = useId();
  const [ isOpen, setIsOpen ] = useState(defaultOpen);
  const calendarId = id ?? `calendar-preview-${generatedId}`;

  return (
    <div
      data-component="CalendarPreview"
      className={CALENDAR_PREVIEW_CLASS_MAP.root}
    >
      <CalendarPreviewHeader
        calendarId={calendarId}
        closeLabel={closeLabel}
        date={date}
        editLabel={editLabel}
        isOpen={isOpen}
        title={title}
        onToggle={() => setIsOpen((open) => !open)}
      />
      <CalendarPreviewPanel
        calendar={calendar}
        id={calendarId}
        isOpen={isOpen}
      />
    </div>
  );
};

CalendarPreview.displayName = "CalendarPreview";
